import { Link } from "react-router-dom";
import PlaybackControls from "~/components/PlaybackControls";
import CookieConsent from "~/components/CookieConsent";

export default function ControlPanel() {
  return (
    <>
      <div className="flex-none border-t-2 border-gray-900 flex items-stretch bg-gray-950">
        {/* Left: Purple section with links - angled edge points to play button */}
        <div className="flex-1 pt-3 pb-3 pl-3 bg-gray-950">
          <div
            className="h-full bg-purple-950 px-3 pr-6 flex flex-col items-start justify-center gap-1.5"
            style={{
              clipPath: 'polygon(0 0, calc(100% - 2.5rem) 0, 100% 50%, calc(100% - 2.5rem) 100%, 0 100%)'
            }}
          >
            <p className="text-sm text-gray-500 text-left leading-tight">
              <Link to="/privacy-policy" className="underline text-gray-400 hover:text-purple-300">Privacy Policy</Link>
            </p>
            <p className="text-sm text-gray-500 text-left whitespace-nowrap leading-tight">
              <span className="text-nowrap">
                &copy; 2025
              </span>
              {" "}
              <a href="https://pressingspace.com" className="underline text-gray-400 hover:text-purple-300 text-nowrap" target="_blank" rel="noreferrer">
                Pressing Space Ltd
              </a>
            </p>
          </div>
        </div>

        {/* Spacing between purple section and play button */}
        <div className="w-3 bg-gray-950"></div>

        {/* Right: Large Play Button - Full height, visually separated */}
        <div className="bg-gray-950 pr-3 py-3 flex items-center">
          <PlaybackControls />
        </div>
      </div>

      {/* Cookie consent positioned at bottom of page */}
      <CookieConsent />
    </>
  );
}
